import { PageLive as Page } from '@/components/orders/new-order/Live';

// const minRequiredPermission = "shop";

// {/* <Script
//       src={`https://maps.googleapis.com/maps/api/js?key=${import.meta.env.VITE_API_KEY}&libraries=places`}
//     /> */}

// {/* <Auth minRequiredPermission={minRequiredPermission}>

//     <div className="component-container">
//       <Live />
//     </div>
//   </Auth> */}

export default function PageLive() {
	return (
		<div className='component-container'>
			<Page />
		</div>
	);
}
